import { createContext } from 'react';

const SignInContext = createContext({
	onLoggedIn: () => {}
});

export default SignInContext;
